import { API_CALLS } from "@/services/apis/index.js";

export default {
  getBCFashionCategories() {
    return new Promise((resolve, reject) => {
      API_CALLS.getBCFashionCategoriesAPI()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  postBCFashionCategories(context, data) {
    console.log(context);
    return new Promise((resolve, reject) => {
      API_CALLS.postBCFashionCategoriesAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  getBCFCategories() {
    return new Promise((resolve, reject) => {
    API_CALLS.getBCFCategoriesAPI()
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postBCFCategories(context, data) {
    console.log(context);
    return new Promise((resolve, reject) => {
    API_CALLS.postBCFCategoriesAPI(data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};
